/**
 * Dieser Code sollte für alle in @shared/api/helpers/sendRequest implementiert sein.
 * Unterschied ist hier die allgemeine Fehlerbehandlung für Serverantworten mit Status >= 400
 */
import Axios from 'axios';
import { addProjectScopeToRoute } from '@shared/api/helpers/addProjectScopeToRoute';
// Vorsicht: Zyklische Referenz, es gibt aber keine bessere Lösung bei dieser Strukturierung des Codes:
// eslint-disable-next-line
import { store } from '../../store';

const axios = Axios.create();
axios.interceptors.response.use((response) => response, handleResponseError);
axios.interceptors.request.use((response) => response, handleRequestError);

function handleResponseError(error) {
  const excludeFromErrorHandling = [
    {
      url: '/login',
      status: [401],
    },
    {
      url: '/onSiteLogin',
      status: [401],
    },
    {
      url: '/register',
      status: [400],
    },
  ];
  if (
    !excludeFromErrorHandling.find(
      (el) =>
        error.config.url.includes(el.url) &&
        el.status.includes(error.response.status)
    )
  ) {
    store.dispatch('setError', error);
  }
  return Promise.reject(error);
}
function handleRequestError(error) {
  return Promise.reject(error);
}
function validateStatus(status) {
  // status-Werte >= 400 erzeugen einen Fehler
  return status < 400;
}

/**
 *
 * @param {string} route
 * @param {string} method
 * @param {object} body
 * @param {object} config
 * @param {string} cstm
 */
export async function sendProjectRequest(
  route,
  method = 'get',
  body,
  config = {},
  cstm
) {
  let reqRoute = route;
  const reqMethod = method.toLowerCase();
  const tokenName =
    route.indexOf('recruiter') !== -1 ? 'recruiterToken' : 'token';
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(tokenName)}`,
  };
  if (config.headers) {
    headers = { ...headers, ...config.headers };
    delete config.headers; // eslint-disable-line
  }
  if (!config.validateStatus) {
    config.validateStatus = validateStatus;
  }
  const requestConfig = { headers, ...config };
  let response;
  if (cstm) {
    reqRoute = addProjectScopeToRoute(reqRoute, cstm);
  }
  switch (reqMethod) {
    case 'get':
      response = await axios[reqMethod](reqRoute, requestConfig);
      break;
    case 'delete':
      requestConfig.data = body; // axios hat eine verwirrende syntax, vgl unten post-Request
      response = await axios[reqMethod](reqRoute, requestConfig);
      break;
    default:
      // Code getestet für post
      response = await axios[reqMethod](reqRoute, body, requestConfig);
      break;
  }
  return response && response.data;
}
